<app-print-layout (cancelar)="cancelar()">
  <div class="p-4 content">
    <div class="card card-outline">
      <div class="card-header d-flex pb-0 no-print">
        <h3>Nota de Auditoria</h3>
      </div>
      <div class="card-body p-2">
        <div>
          <!-- Cabeçalho -->
          <div class="row text-center">
            <div class="col-12 py-2">
              <strong>Nota de Auditoria nº {{ model?.numero }} - OSA nº {{ model?.documentoAssociado }}</strong>
            </div>
          </div>

          <!-- Localidade e Data -->
          <div class="row">
            <div class="col-12 text-right py-2">
              <p>
                Vitória - ES,
                {{ today | date:'dd' }} de
                {{ today | date:'MMMM' }} de
                {{ today | date:'yyyy' }}
              </p>
            </div>
          </div>

          <!-- Destinatário -->
          <div class="row border-bottom">
            <div class="col-12 p-2">
              <p><strong>Prezado(a) Sr(a) {{ model?.nomeResponsavel }}</strong></p>
              <p><strong>{{ model?.cargoResponsavel }}</strong></p>
            </div>
          </div>

          <!-- Itens/Constatações -->
          <div *ngFor="let item of model?.item; let i = index">
            <!-- Constatação -->
            <div class="row p-2">
              <div class="col-12">
                <p><strong>Constatação nº {{ item?.numero }}</strong></p>
                <div [innerHTML]="item?.descricaoConstatacao"></div>
              </div>
            </div>

            <!-- Recomendação -->
            <div class="row p-2">
              <div class="col-12">
                <p><strong>Recomendação para Constatação nº {{ item?.numero }}</strong></p>
                <div [innerHTML]="item?.descricaoRecomendacao"></div>
              </div>
            </div>

            <!-- Arquivos da Constatação -->
            <div class="row p-2" *ngIf="item?.anexo && item?.anexo.length > 0">
              <div class="col-12">
                <p><strong>Arquivos da constatação nº {{ item?.numero }}</strong></p>
                <div *ngFor="let anexo of item?.anexo">
                  <p>{{ anexo?.nomeArquivo }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Prazo Limite -->
          <div class="row p-2">
            <div class="col-12">
              <p><strong>Prazo limite para resposta desta NA: </strong><span *ngIf="model?.prazo">{{ model?.prazo | date: 'dd' }} de {{ model?.prazo | date: 'MMMM' }} de {{ model?.prazo | date: 'yyyy' }}</span>
              </p>
            </div>
          </div>

          <!-- Atenciosamente -->
          <div class="row p-2">
            <div class="col-12">
              <p>Atenciosamente,</p>
            </div>
          </div>

          <!-- Assinaturas -->
          <div class="row">
            <div class="col-6 p-3 text-center" *ngFor="let auditor of equipe">
              <p class="mt-5"><strong>{{ auditor?.nomeAuditor }}</strong></p>
              <p>Auditor do Estado</p>
            </div>
          </div>

          <!-- Aprovação -->
          <div class="row p-2">
            <div class="col-12">
              <p><strong>Aprovado em:</strong> {{ model.dataEnvioAprovado | date:'dd/MM/yyyy' }}</p>
            </div>
          </div>

          <!-- Coordenador -->
          <div class="row p-3 text-center">
            <div class="col-12">
              <p class="mt-5"><strong>{{nomeAuditor}}</strong></p>
              <p>Coordenador de Auditoria</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-print-layout>
